<template lang="pug">
md-layout(md-column='', md-align='start')
  md-theme(md-name='brown-white')
    breadcrumbs(section='Reporting', :nav='nav')

  md-theme(md-name='blue')
    licensing-report-table
</template>

<script>
import { mapState } from 'vuex';
import LicensingReportTable from '../../shared-components/report/LicensingReportTable';
import Breadcrumbs from '../../shared-components/Breadcrumbs';

export default {
  components: {
    LicensingReportTable,
    Breadcrumbs
  },
  computed: {
    ...mapState({
      useraccount: state => state.user.useraccount,
      siteuser: state => state.user.siteuser
    }),
    nav() {
      return [{ title: 'Licensing' }];
    }
  }
};
</script>

<style lang="scss">
.on-left {
  margin-top: -5px;
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/spa/reporting/Licensing.vue